'use strict';

/**
 * Generates recaptcha token
 * @returns {string} recatpcha token
 */
async function grecaptchaGenerateToken() {
    var token = '';

    if (typeof grecaptcha !== 'undefined') {
        // eslint-disable-next-line no-undef
        token = await grecaptcha.execute($('#google-recaptcha-main').data('google-recaptchav3-key'), {
            action: 'submit'
        });
    }

    return token;
}

module.exports = {
    grecaptchaGenerateToken: grecaptchaGenerateToken
};
